import { toRem, toRems } from 'helpers/theme'
import { keyframes } from '@emotion/core'

const pulsLogo = maxOpacity =>
    keyframes({
        '0%': {
            opacity: maxOpacity
        },
        '50%': {
            opacity: 0
        },
        '100%': {
            opacity: maxOpacity
        }
    })

/* eslint-disable quote-props */
const style = ({ theme, height, maxOpacity }) => ({
    height: `${height}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.white,
    textAlign: 'center',
    padding: toRems([20]),
    '& .loader_logo': {
        width: toRem(100),
        animationName: pulsLogo(maxOpacity),
        animationDuration: '3s',
        animationIterationCount: 'infinite',
        '& svg': {
            path: {
                fill: theme.colors.white
            }
        }
    }
})

export default style
